import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { RefinProvider } from '@/providers/refin';
import { useGetMe } from '@/hooks/shared/useGetMe';
import { ReportingMode } from '@/containers/Reporting/ReportingMode';
import { DashBalanceInfo } from '../../components/DashBalanceInfo';
import { DashPaymentInfo } from '../../components/DashPaymentInfo';
import { RiskFactorStatus } from '../../components/RiskFactorStatus';
import { AvailableRefinLoans } from '../../components/AvailableRefinLoans';
import { DashboardMessages } from '../../components/DashboardMessages';
import { AmlNotifications } from '../../components/AmlNotifications';
import { ReportingWarning } from '../../components/ReportingWarning';
import s from './index.module.scss';

export const CombinedView = () => {
  const { t } = useTranslation('dashboard');
  const { user } = useGetMe();

  return (
    <div className={s.wrapper}>
      <div className="container-inner">
        <div className={s.content}>
          <h1 className={classnames(s.title, 'f-h3 f-500')}>
            {user?.first_name
              ? t('dashboard_page.hey_user_welcome_back', { name: user.first_name })
              : t('dashboard_page.welcome_back')}
          </h1>
          <AmlNotifications />
          <DashboardMessages />
          <ReportingWarning />
          <section className={s.summary}>
            <DashBalanceInfo />
            <DashPaymentInfo />
            <RiskFactorStatus />
          </section>
          <ReportingMode className={s.reporting} />
          <RefinProvider>
            <AvailableRefinLoans />
          </RefinProvider>
        </div>
      </div>
    </div>
  );
};